var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    className: "chat-magnifier",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8753 12.3319C14.9516 11.0321 15.5958 9.37983 15.5958 7.58127C15.5958 3.39425 12.1045 0 7.79788 0C3.49123 0 0 3.39425 0 7.58127C0 11.7683 3.49123 15.1625 7.79788 15.1625C9.64782 15.1625 11.3473 14.5362 12.6842 13.4898L16.2303 16.9373C16.5525 17.2506 17.0655 17.2506 17.3877 16.9373C17.723 16.6113 17.723 16.0728 17.3877 15.7468L13.8753 12.3319ZM13.9114 7.58127C13.9114 10.8639 11.1743 13.525 7.79788 13.525C4.42146 13.525 1.68434 10.8639 1.68434 7.58127C1.68434 4.29865 4.42146 1.63755 7.79788 1.63755C11.1743 1.63755 13.9114 4.29865 13.9114 7.58127Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.3e51df5c932274092ad39e828a1dcf60.svg";
export { ForwardRef as ReactComponent };